<template>
    <div class="sr-app-container">
        <div class="sr-app-container__sidebar" :class="{ collapsed: isClosed }">
            <slot name="sidebar" />
        </div>
        <div class="sr-app-container__content">
            <slot name="content" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SrAppContainer',
    props: {
        hideSidebar: Boolean,
    },
    data() {
        return {
            isClosed: localStorage.getItem('mc-navigation-state') === 'closed',
        };
    },
    mounted() {
        window.addEventListener('message', this.onToggleMenu);
    },
    destroyed() {
        window.removeEventListener('message', this.onToggleMenu);
    },
    methods: {
        onToggleMenu(event) {
            if (event?.data?.key === 'mc-navigation-state') {
                localStorage.setItem('mc-navigation-state', event.data.value);
                this.isClosed = event.data.value === 'closed';
            }
        },
    },
};
</script>
